import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ContentBriefBlockWrapperProps {
  blockIndex: number
  isEditing: boolean
  hasComment: boolean
  onClick: () => void
  onKeyDown: (e: React.KeyboardEvent) => void
  className?: string
  children: ReactNode
}

export const ContentBriefBlockWrapper: React.FC<ContentBriefBlockWrapperProps> = ({
  blockIndex,
  isEditing,
  hasComment,
  onClick,
  onKeyDown,
  className,
  children,
}): ReactNode => (
  <div
    className={cn(
      'content-brief-block group my-0.5 min-w-0 overflow-hidden rounded-md border border-transparent transition-colors',
      !isEditing && 'cursor-pointer hover:border-border hover:bg-accent/30',
      hasComment && !isEditing && 'border-primary/20 bg-primary/5',
      isEditing && 'border-primary bg-primary/5',
      className
    )}
    onClick={onClick}
    onKeyDown={onKeyDown}
    role="note"
    aria-label="Content block"
    tabIndex={isEditing ? -1 : 0}
    data-block-index={blockIndex}
  >
    {children}
  </div>
)
